import React, { useState } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";

const DatabaseConnectionsForm = ({ connections, onChange }) => {
  const [showPasswords, setShowPasswords] = useState({});

  const addConnection = () => {
    const newConnection = {
      name: "",
      type: "POSTGRESQL",
      host: "",
      port: 5432,
      database: "",
      username: "",
      password: "",
      connectionString: "",
      isActive: true,
    };
    onChange([...connections, newConnection]);
  };

  const updateConnection = (index, field, value) => {
    const updated = [...connections];
    updated[index][field] = value;
    onChange(updated);
  };

  const removeConnection = (index) => {
    const updated = connections.filter((_, i) => i !== index);
    onChange(updated);
  };

  const togglePasswordVisibility = (index) => {
    setShowPasswords((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const getDefaultPort = (type) => {
    switch (type) {
      case "POSTGRESQL":
        return 5432;
      case "MYSQL":
        return 3306;
      case "MONGODB":
        return 27017;
      case "REDIS":
        return 6379;
      default:
        return 5432;
    }
  };

  const handleTypeChange = (index, newType) => {
    updateConnection(index, "type", newType);
    updateConnection(index, "port", getDefaultPort(newType));
  };

  return (
    <div>
      {connections.map((conn, index) => (
        <Card key={index} className="mb-3">
          <CardBody>
            <Row>
              <Col md={3}>
                <FormGroup>
                  <Label>Nombre *</Label>
                  <Input
                    value={conn.name}
                    onChange={(e) =>
                      updateConnection(index, "name", e.target.value)
                    }
                    placeholder="Mi Base de Datos"
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Tipo *</Label>
                  <Input
                    type="select"
                    value={conn.type}
                    onChange={(e) => handleTypeChange(index, e.target.value)}
                  >
                    <option value="POSTGRESQL">PostgreSQL</option>
                    <option value="MYSQL">MySQL</option>
                    <option value="MONGODB">MongoDB</option>
                    <option value="BIGQUERY">BigQuery</option>
                    <option value="REDIS">Redis</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Host</Label>
                  <Input
                    value={conn.host}
                    onChange={(e) =>
                      updateConnection(index, "host", e.target.value)
                    }
                    placeholder="localhost"
                    disabled={conn.type === "BIGQUERY"}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Puerto</Label>
                  <Input
                    type="number"
                    value={conn.port}
                    onChange={(e) =>
                      updateConnection(index, "port", parseInt(e.target.value))
                    }
                    disabled={conn.type === "BIGQUERY"}
                  />
                </FormGroup>
              </Col>
            </Row>

            {conn.type === "MONGODB" && (
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label>Connection String</Label>
                    <Input
                      type="textarea"
                      rows="2"
                      value={conn.connectionString}
                      onChange={(e) =>
                        updateConnection(
                          index,
                          "connectionString",
                          e.target.value
                        )
                      }
                      placeholder="mongodb://username:password@host:port/database"
                    />
                    <small className="text-muted">
                      Use connection string for MongoDB (alternative to
                      individual fields)
                    </small>
                  </FormGroup>
                </Col>
              </Row>
            )}

            {conn.type === "BIGQUERY" && (
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Project ID</Label>
                    <Input
                      value={conn.database}
                      onChange={(e) =>
                        updateConnection(index, "database", e.target.value)
                      }
                      placeholder="your-project-id"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Service Account Key File Path</Label>
                    <Input
                      value={conn.connectionString}
                      onChange={(e) =>
                        updateConnection(
                          index,
                          "connectionString",
                          e.target.value
                        )
                      }
                      placeholder="/path/to/service-account-key.json"
                    />
                  </FormGroup>
                </Col>
              </Row>
            )}

            {!["MONGODB", "BIGQUERY"].includes(conn.type) && (
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label>Base de Datos</Label>
                    <Input
                      value={conn.database}
                      onChange={(e) =>
                        updateConnection(index, "database", e.target.value)
                      }
                      placeholder="nombre_db"
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Usuario</Label>
                    <Input
                      value={conn.username}
                      onChange={(e) =>
                        updateConnection(index, "username", e.target.value)
                      }
                      placeholder="usuario"
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Contraseña</Label>
                    <div className="position-relative">
                      <Input
                        type={showPasswords[index] ? "text" : "password"}
                        value={conn.password}
                        onChange={(e) =>
                          updateConnection(index, "password", e.target.value)
                        }
                        placeholder="contraseña"
                        style={{ paddingRight: "45px" }}
                      />
                      <Button
                        type="button"
                        color="link"
                        size="sm"
                        className="position-absolute top-50 end-0 translate-middle-y pe-2"
                        onClick={() => togglePasswordVisibility(index)}
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          zIndex: 10,
                        }}
                      >
                        <i
                          className={`fas ${
                            showPasswords[index] ? "fa-eye-slash" : "fa-eye"
                          } text-muted`}
                        ></i>
                      </Button>
                    </div>
                  </FormGroup>
                </Col>
              </Row>
            )}

            <div className="d-flex justify-content-between align-items-center">
              <FormGroup check>
                <Input
                  type="checkbox"
                  checked={conn.isActive}
                  onChange={(e) =>
                    updateConnection(index, "isActive", e.target.checked)
                  }
                />
                <Label check>Activo</Label>
              </FormGroup>
              <Button
                color="danger"
                size="sm"
                onClick={() => removeConnection(index)}
              >
                <i className="fas fa-trash"></i>
              </Button>
            </div>
          </CardBody>
        </Card>
      ))}

      <Button color="outline-primary" onClick={addConnection} className="mb-4">
        <i className="fas fa-plus me-2"></i>
        Agregar Conexión de Base de Datos
      </Button>
    </div>
  );
};

export default DatabaseConnectionsForm;
